class ByteDance{
    constructor() {
        this.name = "ByteDance"
    }
    qiyu(){
        location.href="https://wxlqkjyxgs.qiyukf.com/client?k=90d344f50c3d6ac29e60360bae8e8639&wp=1&robotShuntSwitch=1&robotId=3425033&sid=3889771"
    }
    //判断当前环境是否是微信小程序
    isme() {
        return navigator.userAgent.indexOf('ToutiaoMicroApp') > -1;
    }
}
export default new ByteDance()